module.exports = __webpack_public_path__ + "img/1518069077.5b064985.jpg";